export default __webpack_public_path__ + "static/media/Seema Kanani .b6b83a3b.png";